import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { UserInvitation } from '../../../../shared/model-typings';
import type { CreateUserInvitationsRequest } from '../../../../typings/api';

import { userInvitationsQueryKey } from './useUserInvitations';

/**
 * Creates user invitations for the given organization.
 * We use a Set to ensure that the emails are unique.
 */
function createUserInvitations(organizationId: number, emails: Set<string>) {
  return post<CreateUserInvitationsRequest, UserInvitation[]>(`/api/organizations/${organizationId}/invite`, {
    emails: Array.from(emails),
  });
}

/**
 * Creates a mutation to create user invitations for the given organization.
 * Shows a count-aware success toast and refetches the invitations list.
 */
export function useCreateUserInvitations(organizationId: number) {
  return useToastedMutation({
    mutationFn: (emails: Set<string>) => createUserInvitations(organizationId, emails),
    successToastMessage: (_response, emails: Set<string>) =>
      (emails.size === 1 ? 'Invitation sent.' : `${emails.size} invitations sent.`),
    onSuccess: () => {
      //  Re-fetch the user invitations query
      queryClient.invalidateQueries(userInvitationsQueryKey);
    },
  });
}
